import React, { useEffect, useState } from "react";
import { FloatingLabelInput } from "../floating-lable/Floating";
import { useDebounce } from "@/hooks/UseDebounce";

type SearchCriteria = {
  limit: number;
  search_key?: string;
  search?:string;
  offset: number;
  sort_key: string;
  sort_order: string;
};

type TableSearchFilterProps = {
  setSearchCriteria: React.Dispatch<React.SetStateAction<SearchCriteria>>;
  placeHolder?: string;
  type?: string;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
};

const TableSearchFilter: React.FC<TableSearchFilterProps> = ({
  setSearchCriteria,
  placeHolder = "Search",
  type = "text",
  inputValue,
  setInputValue,
}) => {
  const debouncedInputValue = useDebounce<string>(inputValue, 500);
  useEffect(() => {
    setSearchCriteria((prev) => {
      const newCriteria: SearchCriteria = { ...prev };

      if (debouncedInputValue.trim() !== "") {
        newCriteria.search_key = debouncedInputValue;
        newCriteria.search=debouncedInputValue;
        newCriteria.offset = 0;
        newCriteria.sort_key = "id";
        newCriteria.sort_order = "desc";
      } else {
        delete newCriteria.search_key;
        delete newCriteria.search
      }

      return newCriteria;
    });
  }, [debouncedInputValue, setSearchCriteria]);

  const handleInputChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    setInputValue(event.target.value);
  };

  const preventLeadingSpace: React.KeyboardEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    if (event.key === " " && !(event.target as HTMLInputElement).value) {
      event.preventDefault();
    }
  };
  return (
    <div className="flex items-center flex-1 space-x-2 mb-2 lg:mb-0">
      <div className="flex items-center relative w-auto">
        {/* search icon */}
        <i className="fa-solid fa-magnifying-glass size-4 text-gray-400 absolute left-1 z-10 ml-2"></i>
        <FloatingLabelInput
          type={type}
          placeholder={placeHolder}
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={preventLeadingSpace}
          id="specificInput"
          className="specific w-52 lg:w-64 pl-8 text-sm placeholder:text-sm text-gray-400 h-8"
        />
      </div>
    </div>
  );
};

export default TableSearchFilter;
